import { createIcon } from '@chakra-ui/icons';

export const MsgContent = createIcon({
  displayName: 'MsgContent',
  viewBox: '0 0 18 18',
  path: [
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 6.85352H6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M11 9.85352H6.2666"
        stroke="currentColor"
        strokeWidth="1.68524"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M9 1.60352C13.1422 1.60352 16.5 4.62527 16.5 8.35352C16.5 9.73577 16.0365 11.0205 15.2438 12.0908L16.1618 15.5153L12.1965 14.4525C11.226 14.8658 10.1452 15.1035 9 15.1035C4.85775 15.1035 1.5 12.0818 1.5 8.35352C1.5 4.62527 4.85775 1.60352 9 1.60352Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
